// @ts-nocheck
import { io } from "socket.io-client";
import { getItemFromLocalStorage } from "../../utils/localStorage/localstorageCrudHandlers";

// const auth = JSON.parse(getItemFromLocalStorage({
//   key: "persist:root"
// })?.auth);

// console.log(auth, "getItemFromLocalStorage")

let auth = {};
try {
  const rootState = getItemFromLocalStorage({ key: "persist:root" });
  if (rootState) {
    auth = rootState.auth ? JSON.parse(rootState?.auth || {}) : {};
  }
} catch (err) {
  console.error("Error parsing localStorage auth:", err);
}

// Resolve the Socket.IO URL:
//   - prefer VITE_SOCKET_URL if defined (the modern path)
//   - otherwise use the same resolver axios uses (`API_BASE_URL`), stripping
//     the "/api" suffix if present. This ensures that when running locally with
//     `VITE_API_URL_LOCAL=http://localhost:8000/api` the socket points to
//     `http://localhost:8000` automatically.
import { API_BASE_URL } from "../../api/baseUrl";

const resolveSocketUrl = () => {
  if (import.meta.env.VITE_SOCKET_URL) return import.meta.env.VITE_SOCKET_URL;
  const apiUrl = API_BASE_URL ?? "";
  if (apiUrl.endsWith("/api")) return apiUrl.slice(0, -4);
  return apiUrl;
};

const socket = io(
  resolveSocketUrl(),
  {
    // Forward userId in the handshake only if it exists (avoids "userId=undefined"
    // on the backend). The backend uses this query to join the `<userId>` room.
    // SEC (audit 12/P0-5): o backend agora deriva a room pessoal do JWT do
    // handshake (auth.token), não mais do query.userId cru. Sem isso o web
    // pararia de receber notificações em tempo real (support_changed, etc).
    auth: auth?.userToken ? { token: auth.userToken } : undefined,
    query: auth?.userId ? { userId: auth.userId } : undefined,
    transports: ["websocket", "polling"],
    // Socket auth is JWT-based (query userId + token in payloads), not cookies.
    // Keep this false so the browser accepts the server's wildcard CORS origin
    // ('*'). With withCredentials:true, a wildcard Access-Control-Allow-Origin is
    // rejected by the browser → connect/disconnect loop. Only bites cross-origin
    // (local 5173→8000); prod is same-origin so it was never exposed there.
    withCredentials: false,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
  },
);

export { socket };